export const API_EMPLOYEE_REGISTRATION = 'corporate/registrations'

export const API_DELETE_BULK = 'corporate/customers/bulk_delete'

export const API_COMPANY_GRADES = (companyId) => `corporate/appointment-requests/company_grades?company_id=${companyId}`

export const API_FAMILY_REGISTRATION = 'corporate/customers/bulk_add_family_members'

export const API_SEARCH_EMPLOYEES =  `corporate/customers/employee_search`

export const API_MARK_DELETE = (id) => `corporate/customers/${id}/move_to_churn`

export const API_MARK_UNDO = (id) => `corporate/customers/${id}/undo_churn`

export const API_UPDATE_EMPLOYEE = (id) => `corporate/customers/${id}`

export const API_HELP_REQUEST = `corporate/customers/request_help`

export const API_HELP_SUBMIT = `corporate/customers/submit_help`

// benefit mailers API's
export const MAIL_SETUP = (contractId) => `corporate/contracts/${contractId}/company_mailers`

export const SHOW_MAILER = (contractId, id) => `corporate/contracts/${contractId}/company_mailers/${id}`

export const UPDATE_MAILER = (contractId, id) => `corporate/contracts/${contractId}/company_mailers/${id}`

export const MAIL_SENDER = (contractId, id) => `/corporate/contracts/${contractId}/company_mailers/${id}/mail_sender`

export const SEND_TEST_MAIL = (contractId, id) => `corporate/contracts/${contractId}/company_mailers/${id}/test_mail`

export const MAILER_INSIGHTS = (contractId) => `corporate/contracts/${contractId}/company_mailers/insights`

export const UNDO_MAILER_CONTENT = (contractId, id) => `corporate/contracts/${contractId}/company_mailers/${id}/undo_content`

export const POST_PRE_LAUNCH = (contractId) => `corporate/contracts/${contractId}/company_mailers/post_launch`

export const BENEFIT_ADOPTION_MAILERS = (contractId) => `corporate/contracts/${contractId}/company_mailers/benefit_mailers`

export const CLONE_MAILER = (contractId, id) => `corporate/contracts/${contractId}/company_mailers/${id}/clone_mailer`

export const CANCEL_SCHEDULED_MAILER = (contractId, id) => `corporate/contracts/${contractId}/company_mailers/${id}/cancel_mailer`


export const API_COMMON_AHC_DENTAL_VISION_METRICS = (startDate, endDate, contractId, benefit_type) => `corporate/utilization/appointments/metrics?contract_id=${contractId ?? ''}&benefit_type=${benefit_type}&start_date=${startDate}&end_date=${endDate}`

export const API_WALLET_UTILIZATION = (startDate, endDate, contractId, benefit_type) => `corporate/utilization/benefits/${benefit_type}/wallet_utilization?contract_id=${contractId ?? ''}&benefit_type=${benefit_type}&start_date=${startDate}&end_date=${endDate}`

export const API_COMMON_AHC_DENTAL_VISION_RATINGS_AND_OPTIONS = (startDate, endDate, contractId, benefit_type) => `corporate/utilization/appointments/ratings_and_options?contract_id=${contractId ?? ''}&benefit_type=${benefit_type}&start_date=${startDate}&end_date=${endDate}`

export const API_COMMON_AHC_DENTAL_VISION_UTILIZATION = (startDate, endDate, filter, contractId, benefit_type) => `corporate/utilization/appointments/utilization?contract_id=${contractId ?? ''}&benefit_type=${benefit_type}&filter=${filter}&start_date=${startDate}&end_date=${endDate}`

export const API_COMMON_AHC_DENTAL_VISION_COST_UTILIZATION = (startDate, endDate, contractId, benefit_type) => `corporate/utilization/appointments/cost_savings?contract_id=${contractId ?? ''}&benefit_type=${benefit_type}&start_date=${startDate}&end_date=${endDate}`

export const API_CONTRACTS = `corporate/contracts`

export const API_UTILIZATION_BENEFIT_LISTS = (company_id) => `corporate/utilization/appointments/benefit_list?${company_id}`


export const API_COMMON_AHC_DENTAL_VISION_ACTIVITY_LOG = (startDate, endDate, str, page, contractId, benefit_type) => `corporate/utilization/appointments/${str}?contract_id=${contractId ?? ''}&benefit_type=${benefit_type}&start_date=${startDate}&end_date=${endDate}&page=${page}`

export const API_COMMON_AHC_DENTAL_VISION_ACTIVITY_LOG_FILTERS = (startDate, endDate, page, contractId, benefit_type, filters) => `corporate/utilization/appointments/activity_log_filters?contract_id=${contractId ?? ''}&benefit_type=${benefit_type}&start_date=${startDate}&end_date=${endDate}&page=${page}&filters=${filters}`

export const API_PHARMACY_ACTIVITY_LOG_FILTERS = (startDate, endDate, page, contractId, benefit_type, filters) => `corporate/utilization/pharmacy/activity_log_filters?contract_id=${contractId ?? ''}&benefit_type=${benefit_type}&start_date=${startDate}&end_date=${endDate}&page=${page}&filters=${filters}`

export const API_CONSULTATION_ACTIVITY_LOG_FILTERS = (startDate, endDate, page, contractId, benefit_type, filters) => `corporate/utilization/consultations/activity_log_filters?contract_id=${contractId ?? ''}&benefit_type=${benefit_type}&start_date=${startDate}&end_date=${endDate}&page=${page}&filters=${filters}`

export const API_COMMON_AHC_DENTAL_VISION_FETCH_PACKAGES = (startDate, endDate, contractId, benefit_type) => `corporate/utilization/appointments/fetch_packages?contract_id=${contractId ?? ''}&benefit_type=${benefit_type}&start_date=${startDate}&end_date=${endDate}`

export const API_COMMON_AHC_DENTAL_VISION_OVERALL = (contractId, benefit_type) => `corporate/utilization/appointments/overall_appointments?contract_id=${contractId  ?? ''}&benefit_type=${benefit_type}`

export const API_COMMON_AHC_DENTAL_VISION_OVERALL_RATINGS = (contractId, benefit_type) => `corporate/utilization/appointments/overall_ratings?contract_id=${contractId  ?? ''}&benefit_type=${benefit_type}`

export const API_COMMON_AHC_DENTAL_VISION_OVERALL_SAVINGS = (contractId, benefit_type) => `corporate/utilization/appointments/overall_cost_savings?contract_id=${contractId  ?? ''}&benefit_type=${benefit_type}`

export const API_COMMON_AHC_DENTAL_VISION_OVERALL_NETWORK = (contractId, benefit_type) => `corporate/utilization/appointments/overall_network?contract_id=${contractId  ?? ''}&benefit_type=${benefit_type}`

export const API_ACTIVITY_LOG = (startDate, endDate, str, page, contractId) => `corporate/utilization/${str}?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}&page=${page}`

export const API_DOCTOR_CONSULTAION_METRICS = (contractId, startDate, endDate) => `corporate/utilization/consultations/metrics?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_DOCTOR_CONSULTAION_USERS = (contractId, startDate, endDate) => `corporate/utilization/consultations/users?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_DOCTOR_CONSULTAION_RATINGS = (contractId, startDate, endDate) => `corporate/utilization/consultations/ratings?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_DOCTOR_CONSULTAION_COVERAGE = (contractId, startDate, endDate) => `corporate/utilization/consultations/coverage?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_DOCTOR_CONSULTAION_UTILIZATION = (contractId, startDate, endDate, filter) => `corporate/utilization/consultations/utilization?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}&filter=${filter}`

export const API_DOCTOR_CONSULTAION_OVERALL = (contractId) => `corporate/utilization/consultations/yearly-consulations?contract_id=${contractId ?? ''}`

export const API_DOCTOR_CONSULTAION_OVERALL_AVGWAIT_TIME = (contractId) => `corporate/utilization/consultations/average-wait-time?contract_id=${contractId ?? ''}`

export const API_DOCTOR_CONSULTAION_OVERALL_REPEATEDUSERS = (contractId) => `corporate/utilization/consultations/repeat-users?contract_id=${contractId ?? ''}`

export const API_DOCTOR_CONSULTAION_OVERALLRATINGS = (contractId) => `corporate/utilization/consultations/overall-ratings?contract_id=${contractId ?? ''}`

export const API_PHARMACY_METRICS = (contractId, startDate, endDate) => `corporate/utilization/pharmacy/metrics?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_PHARMACY_RATINGS = (contractId, startDate, endDate) => `corporate/utilization/pharmacy/ratings?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_PHARMACY_SPENDINGS = (contractId, startDate, endDate) => `corporate/utilization/pharmacy/spend?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_PHARMACY_COVERAGE = (contractId, startDate, endDate) => `corporate/utilization/pharmacy/coverage?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_HRA_METRICS = (contractId, startDate, endDate) => `corporate/utilization/hra/metrics?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_HRA_UTILIZATION = (contractId, startDate, endDate, filter) => `corporate/utilization/hra/utilization?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}&filter=${filter}`

export const API_FITNESS_METRICS = (contractId, startDate, endDate) => `corporate/utilization/fitness/metrics?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_FITNESS_COMMENTS = (contractId, startDate, endDate) => `corporate/utilization/fitness/comments?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_FITNESS_RATINGS = (contractId, startDate, endDate) => `corporate/utilization/fitness/ratings?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_FITNESS_UTILIZATION = (contractId, startDate, endDate) => `corporate/utilization/fitness/utilization?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_HEALTH_COACH_METRICS = (contractId, startDate, endDate) => `corporate/utilization/health_coach/metrics?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_HEALTH_COACH_MEDICAL = (contractId, startDate, endDate) => `corporate/utilization/health_coach/distribution?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_VACCINATION_METRICS = (contractId, startDate, endDate) => `corporate/utilization/vaccination/metrics?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_VACCINATION_RATINGS = (contractId, startDate, endDate) => `corporate/utilization/vaccination/ratings?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_VACCINATION_UTILIZATION = (contractId, filter, startDate, endDate) => `corporate/utilization/vaccination/utilization?contract_id=${contractId ?? ''}&filter=${filter}&start_date=${startDate}&end_date=${endDate}`

export const API_VACCINATION_FUTURE_APPOINTMENTS = (contractId, startDate, endDate) => `corporate/utilization/vaccination/future_appointments?contract_id=${contractId ?? ''}&start_date=${startDate}&end_date=${endDate}`

export const API_COMMON_AHC_DENTAL_VISION_ACTIVITY_LOG_DOWNLOAD = (str, start_date, end_date, contractId, benefit_type, filters) => `corporate/utilization/appointments/download?contract_id=${contractId ?? ''}&benefit_type=${benefit_type}&start_date=${start_date}&end_date=${end_date}&filters=${filters}`

export const API_PHARMACY_ACTIVITY_LOG_DOWNLOAD = (start_date, end_date, contractId) => `corporate/utilization/pharmacy/download?contract_id=${contractId ?? ''}&start_date=${start_date}&end_date=${end_date}`

export const API_CONSULTATION_ACTIVITY_LOG_DOWNLOAD = (start_date, end_date, contractId, filters) => `corporate/utilization/consultations/download?contract_id=${contractId ?? ''}&start_date=${start_date}&end_date=${end_date}&filters=${filters}`

export const API_ACTIVITY_LOG_DOWNLOAD = (str, start_date, end_date, contractId) => `corporate/utilization/${str}download?contract_id=${contractId ?? ''}&start_date=${start_date}&end_date=${end_date}`

export const LOGIN_API = 'corporate/login'

export const LOGOUT_API = 'corporate/logout'

export const SAML_LOGIN_API = 'corporate/sso-create'

export const FORGOT_USERNAME_API = 'corporate/forgot_password'

export const RESET_PASSWORD_API = 'corporate/reset_password'

export const MFA_DETAILS = 'corporate/two_factor_settings/new'

export const MFA_DELETE = 'corporate/two_factor_settings'

export const MFA_SKIP = 'corporate/two_factor_settings/skip_enable_mfa'

export const MFA_AUTH = 'corporate/two_factor_settings'

export const MFA_AUTH_APP = 'corporate/two_factor_settings/mfa_qr_code'

export const MFA_AUTH_OTP = 'corporate/two_factor_settings/mfa_otp_code'

export const MFA_RESEND_OTP = 'corporate/two_factor_settings/resend_otp'

export const MFA_QR_CODE = 'corporate/two_factor_settings/qr_code'

export const MFA_OTP_CODE = 'corporate/two_factor_settings/otp_code'

export const MFS_CREATE = 'corporate/two_factor_settings/mfa_create'


export const API_FETCH_RECENT_UPLOADS = (type) => `corporate/customer_data_uploads?type=${type}`

export const API_FETCH_DEACTIVATE_RECENT_UPLOADS = 'corporate/customer_data_deletions'

export const API_UPLOAD_FILE_STATUS = (id) => `corporate/customer_data_uploads/${id}`

export const API_DEACTIVATE_UPLOAD_FILE_STATUS = (id) => `corporate/customer_data_deletions/${id}`

export const API_RECENT_UPLOAD_DETAILS = (id, page) => `corporate/customer_data_uploads/show_details/${id}?page=${page+1}`

export const API_DEACTIVATE_RECENT_UPLOAD_DETAILS = (id, page) => `corporate/customer_data_deletions/show_details/${id}?page=${page+1}`

export const API_FETCH_FAMILY_MEMBERS = (id) => `corporate/family_members?id=${id}`

export const API_UPDATE_FAMILY_MEMBERS = (id) => `corporate/family_members/${id}`

export const API_FETCH_ENTITY_DETAILS = (id) => `corporate/customers/entities`

export const API_SPENDING_ACCOUNT_UTILIZATION = (contractId, startDate, endDate) => `corporate/utilization/spending_account/health_checks/month_wise_utilization?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_SPENDING_ACCOUNT_DATA = (contractId, startDate, endDate) => `corporate/utilization/spending_account/health_checks?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_SPENDING_ACCOUNT_RATINGS =  (contractId, startDate, endDate) => `corporate/utilization/spending_account/health_checks/ratings?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_VACCINATION_OVERALL = (contractId) => `corporate/utilization/vaccination/overall?contract_id=${contractId}`

export const API_VACCINATION_OVERALL_RATINGS = (contractId) => `corporate/utilization/vaccination/overall-ratings?contract_id=${contractId}`

export const API_VACCINATION_OVERALL_SAVINGS = (contractId) => `corporate/utilization/vaccination/overall-savings?contract_id=${contractId}`

export const API_VACCINATION_OVERALL_NETWORK = (contractId) => `corporate/utilization/vaccination/overall-network?contract_id=${contractId}`

export const API_FETCH_INVOICES = (company_id) => `corporate/company_invoices?${company_id}`

export const API_DOWNLOAD_INVOICES = 'corporate/company_invoices/download'

export const API_FETCH_MIS_SUMMARY = 'corporate/company_invoice_items'

export const API_MIS_FETCH_PARTICIPANTS_LIST = 'corporate/company_invoice_items/participation_list'

export const API_INVOICE_CONFIRM = 'corporate/company_invoice_items/confirm'

export const API_INVOICE_DISPUTE = 'corporate/company_invoice_items/dispute'

export const API_DOWNLOAD_PARTICIPATION_LIST = 'corporate/company_invoice_items/send_participant_list.csv'

export const API_STEPATHON_LIST_AND_CREATE = 'corporate/stepathons'

export const API_STEPATHON_UPDATE = (id) =>  `corporate/stepathons/${id}`

export const API_STEPATHON_DEACTIVATE = (id) =>`corporate/stepathons/${id}/deactivate`

export const API_STEPATHON_ACTIVATE = (id) =>`corporate/stepathons/${id}/activate`

export const API_METRIC_LEADERBOARD = (id) =>`corporate/stepathon/leaderboard/${id}/metrics`

export const API_TEAM_LIST_LEADERBOARD = (id, term) =>`corporate/stepathon/leaderboard/${id}/team_list`

export const API_TEAM_MEMBER_LIST_LEADERBOARD = (id, team_id, term) =>`corporate/stepathon/leaderboard/${id}/${team_id}/team_step_history?search=${term}`

export const API_TEAM_LIST_PAGE = (id) =>`corporate/stepathon/${id}/teams`

export const API_MEMBER_LIST_PAGE = (id, term) =>`corporate/stepathon/${id}/individual?search=${term}`

export const API_TEAM_MEMBER_LIST_PAGE = (id, team_id, term) =>`corporate/stepathon/${id}/teams/${team_id}/members?search=${term}`

export const API_INDIVIDUAL_MEMBER_LIST_LEADERBOARD = (id, term) =>`corporate/stepathon/leaderboard/${id}/member_list?search=${term}`

export const DOWNLOAD_CSV_DATA_LEADERBOARD = (id, type) =>`corporate/stepathon/leaderboard/${id}/download_csv.csv?type=${type}`

export const API_STEPATHON_TEAM_UPLOAD = `corporate/stepathon/teams/data_uploads`

export const API_STEPATHON_MEMBER_UPLOAD = 'corporate/stepathon/individual/data_uploads'

export const API_STEPATHON_TEAM_UPLOAD_STATUS = (id) => `corporate/stepathon/teams/data_uploads?id=${id}`

export const API_STEPATHON_UPLOADER_BUG_REPORT = (id) => `corporate/stepathon/data_uploads/${id}/download`

export const API_FOR_MANAGE_EMPLOYEE_METRIC_CARD = 'corporate/customers/manage_employee_metric'

export const API_FOR_BULK_DEACTIVATE_EMPLOYEES = 'corporate/customers/bulk_deactivate_customers'

export const API_FOR_ACTIVATE_EMPLOYEES = (id) =>  `corporate/customers/${id}/customer_activate`

//pre-emp API's

export const FETCH_PROVIDERS_DETAILS = (customerId, id, ent_id, pincode) => {
  let url = `corporate/customers/${customerId}/appointment-requests/provider_address?appointment_id=${id}&enterprise_id=${ent_id}`
  if (pincode) { url += `&pincode=${pincode}`}
  return url
}

export const FETCH_ENTERPRISE_DETAILS = (customerId, id) => `corporate/customers/${customerId}/appointment-requests/enterprises?appointment_id=${id}`

export const RESCHEDULE_APPOINTMENT = 'corporate/appointment-requests/update'

export const API_ADD_EMPLOYEE = 'corporate/customers/add_employee'

export const API_PRE_EMP_BULK_UPLOAD = 'corporate/upload-appointment-requests'

export const API_UPDATE_APPT_REQ = `corporate/appointment-requests/customer_update`

export const API_PRE_EMP_UPLOAD_STATUS = (id) => `corporate/uploader_status/${id}`

export const API_PRE_EMP_BUSINESS_UNIT = (companyId) => `corporate/appointment-requests/company_business_units?company_id=${companyId}`

export const API_PRE_EMP_CHECK_UP = 'corporate/appointment-requests'

export const API_PRE_EMP_RECENT_UPLOAD = (type) => `corporate/recent-upload?type=${type}`

export const FETCH_TOTAL_RECORDS = (companyId, type) => `corporate/appointment-requests/new_total_records?company_id=${companyId}&type=${type}`

export const FETCH_PRE_EMP_RECORDS_API = 'corporate/appointment-requests'

export const DOWNLOAD_PRE_EMP_REPORTS = (id) => `corporate/appointment-requests/${id}/download_report`

export const DOWNLOAD_CSV_FILE = (type) => `corporate/appointment-requests/download_csv_file?type=${type}`

export const UPLOAD_CSV_FILE  = `corporate/appointment-requests/new_download_csv`

export const DOWNLOAD_PRE_EMP_VOUCHER = 'corporate/appointment-requests/download_voucher'

export const DOWNLOAD_RECENT_PRE_EMP_UPLOAD = (id, type) => `corporate/recent-upload/${id}/download_report?type=${type}`

export const API_PRE_EMP_RECENT_UPLOAD_DETAILS = (id, page) => `corporate/show_details/${id}?page=${page+1}`

export  const API_NETWORK_VIEWPAGE = ({id, page=1, enterprise_id='', city=''})=> `corporate/benefits/${id}/network?page=${page}&enterprise_id=${enterprise_id}&city=${city}`

export const API_HOME_COLLECTION_LIST = ({id, page=1, pincode=''}) => `corporate/benefits/${id}/home_collection_network?page=${page}&pincode=${pincode}`

export  const API_NETWORK_CITYLIST = ({id, enterprise_id=''})=> `corporate/benefits/${id}/city_list?enterprise_id=${enterprise_id}`

export  const API_PACKAGE_DESCRIPTION = ({id})=> `corporate/benefits/${id}/packages_description`

export  const API_ENTERPRISE_LIST = ({id})=> `corporate/benefits/${id}/enterprise_list`

export  const API_FETCH_DOWNLOAD_NETWORK_PROVIDERS = (id)=> `corporate/benefits/${id}/queue_download_network`

export  const API_DOWNLOAD_NETWORK_PROVIDERS = (id)=> `corporate/benefits/${id}/download_network`

export const API_GET_CHALLENGES_ANALYTICS = (contractId, startDate, endDate) => `corporate/challenges-leaderboard?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_DEMOGRAPHICS_ANALYTICS = (contractId, startDate, endDate) => `corporate/demographics?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_STEPS_ANALYTICS = (contractId, startDate, endDate) => `corporate/steps-leaderboard?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const GET_TEST_RESULTS_ANALYTICS = (contractId, startDate, endDate, companyId) => `corporate/test-results?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}&company_id=${companyId}`

export const GET_BP_TEST_RESULTS = (contractId, startDate, endDate, companyId) => `corporate/test-results/blood_pressure?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}&company_id=${companyId}`

export const GET_CBC_TEST_RESULTS = (contractId, startDate, endDate, companyId) => `corporate/test-results/cbc?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}&company_id=${companyId}`

export const GET_DIABETES_TEST_RESULTS = (contractId, startDate, endDate, companyId) => `corporate/test-results/diabetes?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}&company_id=${companyId}`

export const GET_KIDNEY_TEST_RESULTS = (contractId, startDate, endDate, companyId) => `corporate/test-results/kidney?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}&company_id=${companyId}`

export const GET_THYROID_TEST_RESULTS = (contractId, startDate, endDate, companyId) => `corporate/test-results/thyroid?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}&company_id=${companyId}`

export const GET_LIPIDS_TEST_RESULTS = (contractId, startDate, endDate, companyId) => `corporate/test-results/lipids?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}&company_id=${companyId}`

export const GET_LIVER_TEST_RESULTS = (contractId, startDate, endDate, companyId) => `corporate/test-results/liver?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}&company_id=${companyId}`

export const GET_URINE_EXAM_TEST_RESULTS = (contractId, startDate, endDate, companyId) => `corporate/test-results/urine_exam?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}&company_id=${companyId}`

export const API_FOR_DOWNLOAD_EMPLOYEE_LIST = `corporate/customers/download`

// overview apis
export const API_OVERVIEW_INIT = (id, startDate, endDate) => `corporate/overview/overview_init?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`

export const API_OVERVIEW_METRIC = (id, startDate, endDate, companyIds) => {
  const baseUrl = `corporate/overview/metrics?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`;
  
  return companyIds ? `${baseUrl}&company_ids[]=${companyIds}` : baseUrl;
};


export const API_OVERVIEW_COST_RATINGS_METRICS = (id, startDate, endDate) => `corporate/overview/cost_ratings_metrics?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`

export const API_OVERVIEW_HEALTH_CHECKS = (id, startDate, endDate) => `corporate/overview/health_checks?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`

export const API_OVERVIEW_CONSULTATIONS = (id, startDate, endDate) => `corporate/overview/consultations?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`

export const API_DENTAL_OVERVIEW = (id, startDate, endDate) => `corporate/overview/dental?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`

export const API_VISION_OVERVIEW = (id, startDate, endDate) => `corporate/overview/vision?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`

export const API_HRA_OVERVIEW = (id, startDate, endDate) => `corporate/overview/hra?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`

export const API_NOT_ENABLED_SERVICES = (id, startDate, endDate) =>  `corporate/overview/not_enabled_services?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`

export const API_HEALTH_CHALLENGE_OVERVIEW = (id, startDate, endDate) => `corporate/overview/health_challenges?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`

export const API_PRE_EMPLOYMENT_OVERVIEW = (id, startDate, endDate) => `corporate/overview/pre_employment?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`

export const API_WELLNESS_CALENDAR_OVERVIEW = (id, startDate, endDate) => `corporate/overview/wellness_calendar?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`

export const API_STEPS_OVERVIEW = (id, startDate, endDate) => `corporate/overview/steps?contract_id=${id}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_LIFESTYLE = (contractId, startDate, endDate) => `corporate/health_risks/lifestyle?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_CONDITIONS = (contractId, startDate, endDate) => `corporate/health_risks/conditions?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_STRESS_ANALYTICS = (contractId, startDate, endDate) => `corporate/health_risks/stress?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_SMOKING_ANALYTICS = (contractId, startDate, endDate) => `corporate/health_risks/smoking?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_ALCOHOL_ANALYTICS = (contractId, startDate, endDate) => `corporate/health_risks/alcohol?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_DIET_ANALYTICS = (contractId, startDate, endDate) => `corporate/health_risks/diet?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_EXERCISE_ANALYTICS = (contractId, startDate, endDate) => `corporate/health_risks/exercise?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_HYPERTENSIVE_ANALYTICS = (contractId, startDate, endDate) => `corporate/health_risks/hypertensive?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_DIABETIC_ANALYTICS = (contractId, startDate, endDate) => `corporate/health_risks/diabetic?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_CVD_ANALYTICS = (contractId, startDate, endDate) => `corporate/health_risks/cvd?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_WEIGHT_ANALYTICS = (contractId, startDate, endDate) => `corporate/health_risks/weight?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_DOWNLOAD_HRA = `corporate/health_risks/download`

export const API_GET_METRIC_EAP_ANALYTICS = (contractId, startDate, endDate) => `corporate/eap?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_LINE_GRA_EAP_ANALYTICS = (contractId, startDate, endDate) => `corporate/eap/month_wise_appointments?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_GET_BAR_GRAPH_EAP_ANALYTICS = (contractId, startDate, endDate) => `corporate/eap/reason_wise_appointments?contract_id=${contractId}&start_date=${startDate}&end_date=${endDate}`

export const API_PROVIDER_SERVICE_NETWORK = `corporate/provider_service_network`

export const FETCH_CALL_RECORDINGS = (id) => `corporate/appointment-requests/${id}/call-recordings`

export const FETCH_MIS_PULSE_LIST = 'corporate/mis_pulses'

export const CREATE_MIS_PULSE = 'corporate/mis_pulses'

export const UPDATE_MIS_PULSE = (id) => `corporate/mis_pulses/${id}`

export const DEACTIVATE_MIS_PULSE = (id) => `corporate/mis_pulses/${id}/deactivate`

export const ACTIVATE_MIS_PULSE = (id) => `corporate/mis_pulses/${id}/activate`

export const TRIGGER_MIS_PULSE = (id) => `corporate/mis_pulses/${id}/trigger`

export const GET_HRMS_SYNC_INTEGRATION = `corporate/hrms_sync_integration`

export const TERMINATE_HRMS_SYNC_CONNECTION = `corporate/hrms_sync_integration/terminate`

export const API_OPD_OVERVIEW_METRICS = (id, startDate, endDate, companyIds, status) => `corporate/opd_overview/metrics?contract_id=${id}&start_date=${startDate}&end_date=${endDate}&company_ids[]=${companyIds}&metrics_status=${status}`

export const API_OPD_BENEFIT_WISE_SPLIT = (id, startDate, endDate, companyIds, service_type) => `corporate/opd_overview/benefit_wise_split?contract_id=${id}&start_date=${startDate}&end_date=${endDate}&company_ids[]=${companyIds}&service_type=${service_type}`

export const API_OPD_STATUS_WISE_SPLIT = (id, startDate, endDate, companyIds, service_type) => `corporate/opd_overview/status_wise_split?contract_id=${id}&start_date=${startDate}&end_date=${endDate}&company_ids[]=${companyIds}&service_type=${service_type}`

export const API_OPD_RELATION_WISE_SPLIT = (id, startDate, endDate, companyIds, service_type) => `corporate/opd_overview/relationship_wise_split?contract_id=${id}&start_date=${startDate}&end_date=${endDate}&company_ids[]=${companyIds}&service_type=${service_type}`

export const API_OPD_TOP_DIAGNOSIS = (id, startDate, endDate, companyIds) => `corporate/opd_overview/top5_service_providers?contract_id=${id}&start_date=${startDate}&end_date=${endDate}&company_ids[]=${companyIds}`

export const API_OPD_TOP_BENEFITS = (id, startDate, endDate, companyIds) => `corporate/opd_overview/top5_benefits?contract_id=${id}&start_date=${startDate}&end_date=${endDate}&company_ids[]=${companyIds}`

export const API_OPD_TOP_REJECTION_REASONS = (id, startDate, endDate, companyIds) => `corporate/opd_overview/top5_rejection_reasons?contract_id=${id}&start_date=${startDate}&end_date=${endDate}&company_ids[]=${companyIds}`

export const API_OPD_TOP_AILMENTS = (id, startDate, endDate, companyIds) => `corporate/opd_overview/top5_ailments?contract_id=${id}&start_date=${startDate}&end_date=${endDate}&company_ids[]=${companyIds}`

export const API_OPD_BENEFIT_WISE_TRENDS = (id, startDate, endDate, companyIds, service_type) => `corporate/opd_overview/benefit_wise_trends?contract_id=${id}&start_date=${startDate}&end_date=${endDate}&company_ids[]=${companyIds}&service_type=${service_type}`

export const API_OPD_OVERALL_TRENDS = (id, startDate, endDate, companyIds) => `corporate/opd_overview/overall_trends?contract_id=${id}&start_date=${startDate}&end_date=${endDate}&company_ids[]=${companyIds}`

export const SEARCH_COMPANIES = (queryString = '') => `corporate/companies/search${queryString ? `?${queryString}` : ''}`
